export const QuestionIdSuffixes = {
    QPAIN: "_QPAIN",
    PAIN_AREAS: "_PAIN_AREAS",
    PAIN_SCALE: "_PAIN_SCALE",
};
